import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export default function EventDescription({ event }) {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} mt={5} spacing={{ xs: 2, sm: 5 }} sx={{ padding: '20px', alignItems: 'center' }}>
            <img src={process.env.REACT_APP_API_URL.concat(event.image)} alt={event.titre} style={{ width: '100%', maxWidth: 300, height: 'auto', objectFit: 'cover', borderRadius: '8px', marginBottom: 16 }} />
            <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h2" sx={{textAlign: { xs: 'center', sm: 'left' }}}>{event.titre}</Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-line', textAlign: { xs: 'justify', sm: 'left' } }}>{event.description}</Typography>
            </Box>
        </Stack>


    )
}